import { Storage } from "aws-amplify";
import { v4 as uuid } from "uuid";
import { amplifyConfig } from "src/aws-config";

export const uploadToS3 = async (
  fileUrl: string,
  path: string = "",
  level: "public" | "protected" | "private" = "public",
  extension: string | null = null
) => {
  const response = await fetch(fileUrl);
  const blob = await response.blob();

  const s3Object: any = await Storage.put(
    `${path}${uuid() as string}${extension !== null ? "." + extension : ""}`,
    blob,
    {
      level,
    }
  );

  return `https://s3-${amplifyConfig.Storage.AWSS3.region}.amazonaws.com/${amplifyConfig.Storage.AWSS3.bucket}/public/${s3Object.key}`;
};
